module.exports = __webpack_public_path__ + "img/local_normal.6809eb9d.png";